export interface SelectOption {
  label: string;
  value: number;
}

export enum OfferType {
  DollarOff = 'dollar_off_offer_type',
  Free = 'free_offer_type',
  PartialDollarOff = 'partial_order_dollar_off_offer_type',
  PercentageOff = 'percentage_off_offer_type',
  PartialPercentageOff = 'partial_order_percentage_off_offer_type',
}

export enum GeneralOfferSelectionType {
  Menu,
  MenuSection,
  Dish,
}

export enum SelectedOfferType {
  Bxgy = 'bxgy',
  General = 'general',
  FreeWithPurchase = 'free_with_purchase',
  FreeWithoutPurchase = 'free_without_purchase',
}
